export default __webpack_public_path__ + "static/media/hard-slide1.e37f3b33.png";